// extracted by mini-css-extract-plugin
module.exports = {"headLabel":"e_Iab","title":"e_Jab","subTitle":"e_Kab","promoted":"e_Lab"};